export const routes = [
  {
    path: "/contratos",
    component: () => import(/* webpackChunkName: "tema" */ "./components/List"),
    name: "contrato.list",
    meta: {
      requiresAuth: true,
    },
  },
];
